import { Pipe, PipeTransform } from '@angular/core';
import { EnumUtils } from '../../core';

@Pipe({
  name: 'productionInEUTranslationKey'
})
export class ProductionInEUTranslationKeyPipe implements PipeTransform {
  transform(state: string): string {
    // We totally reworked the handling of the status/type/...
    // So high likely we missed some cases, therefore check if the state
    // is undefined and dont show a translation-key with undefined, but show
    // just an empty string as a placeholder.
    if (!state || !state.length) {
      return '';
    }
    return EnumUtils.getProductionInEUTranslationKey(state);
  }
}
